import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiPath } from '@/constants/defaultValues';
import { Delete, Get, Post, Put } from '@/api/api-middleware';
import { getCompanyID, isHrEmployee } from '@/helpers/Utils';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  permissionTypeList: [],
  viewPermissionTypeList: [],
  permissionSettingList:[],
  permissionTypeItem: {},
  permissionSettingItem: {},
  permissionTypeAddUpdateDelete: {},
  loading: false,
  notification: { show: false, code: '' },
  error: '',
};

export const fetchPermissionType = createAsyncThunk(
  'permissionType/fetchPermissionType',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}api/Lookup/PermissionType/GetAll`,
        data: {
          companyID: params?.companyID,
          isFromHr: params?.isFromHr,
          date: params?.date,
          checkDate: params?.checkDate,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchPermissionSettings = createAsyncThunk(
  'permissionType/fetchPermissionSettings',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}api/Lookup/PermissionSetting/GetAll`,
        data: {
          companyID: params?.companyID,
          isFromHr: params?.isFromHr,
          date: params?.date,
          checkDate: params?.checkDate,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchPermissionTypesForView = createAsyncThunk(
  'permissionType/fetchPermissionTypesForView',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}api/Lookup/PermissionType/GetAll`,
        data: {
          companyID: params?.companyID,
          isFromHr: params?.isFromHr,
          date: params?.date,
          checkDate: false,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addPermissionType = createAsyncThunk(
  'permissionType/addPermissionType',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Lookup/PermissionType/Add'}`,
        data: params,
      });
      thunkAPI.dispatch(fetchPermissionTypesForView(params));
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addPermissionSetting = createAsyncThunk(
  'permissionType/addPermissionSetting',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Lookup/PermissionSetting/Add'}`,
        data: params,
      });
      if(response?.data?.errCode == '200'){
        thunkAPI.dispatch(fetchPermissionSettings(params));
      }
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getPermissionTypeById = createAsyncThunk(
  'permissionType/getPermissionTypeById',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}api/Lookup/PermissionType/GetByID/${params}`,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getPermissionSettingById = createAsyncThunk(
  'permissionType/getPermissionSettingById',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}api/Lookup/PermissionSetting/GetByID/${params}`,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updatePermissionType = createAsyncThunk(
  'permissionType/updatePermissionType',
  async (params, thunkAPI) => {
    try {
      const response = await Put({
        url: `${apiPath}${'api/Lookup/PermissionType/Update'}`,
        data: params,
      });
      thunkAPI.dispatch(
        fetchPermissionTypesForView({
          companyID: getCompanyID(),
          isFromHr: isHrEmployee(),
          date: new Date(),
          checkDate: false,
        })
      );
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updatePermissionSetting = createAsyncThunk(
  'permissionType/updatePermissionSetting',
  async (params, thunkAPI) => {
    try {
      const response = await Put({
        url: `${apiPath}${'api/Lookup/PermissionSetting/Update'}`,
        data: params,
      });
      if(response?.data?.errCode == '200'){
        thunkAPI.dispatch(fetchPermissionSettings(params));
      }
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deletePermissionType = createAsyncThunk(
  'permissionType/deletePermissionType',
  async (params, thunkAPI) => {
    try {
      const response = await Delete({
        url: `${apiPath}api/Lookup/PermissionType/Delete/${params}`,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deletePermissionSetting = createAsyncThunk(
  'permissionType/deletePermissionSetting',
  async (params, thunkAPI) => {
    try {
      const response = await Delete({
        url: `${apiPath}api/Lookup/PermissionSetting/Delete/${params}`,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const permissionTypeSlice = createSlice({
  name: 'permissionType',
  initialState,
  reducers: {
    clearPermissionTypeList: (state) => {
      state.permissionTypeList = [];
      state.permissionSettingItem = {};
    },
    clearCurrentItem: (state) => {
      permissionTypeList = [];
      viewPermissionTypeList = [];
      permissionSettingList =[];
      permissionTypeItem = {};
      permissionSettingItem = {};
      permissionTypeAddUpdateDelete = {};
      loading = false;
      notification = { show: false, code: '' };
      error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissionType.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
      })
      .addCase(fetchPermissionType.fulfilled, (state, action) => {
        state.loading = false;
        const permissionTypeList = action.payload;
        if (permissionTypeList && permissionTypeList?.length > 0) {
          state.permissionTypeList = permissionTypeList?.map((item) => ({
            ...item,
            nameAr: item?.nameAr,
            nameEn: item?.nameEn,
            label: getLabel(item?.nameAr, item?.nameEn),
            id: item?.id,
            value: item?.id,
            workFlowID: item?.workFlowID,
          }));
        } else {
          state.permissionTypeList = permissionTypeList;
        }
        state.error = '';
      })
      .addCase(fetchPermissionType.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeList = [];
        state.error = action.payload ?? 'An error occurred';
      });
      builder
      .addCase(fetchPermissionSettings.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
      })
      .addCase(fetchPermissionSettings.fulfilled, (state, action) => {
        state.loading = false;
        const permissionSettingList = action.payload;
        if (permissionSettingList && permissionSettingList?.length > 0) {
          state.permissionSettingList = permissionSettingList?.map((item) => ({
            ...item,
            nameAr: item?.nameAr,
            nameEn: item?.nameEn,
            label: getLabel(item?.nameAr, item?.nameEn),
            id: item?.id,
            value: item?.id,
            workFlowID: item?.workFlowID,
          }));
        } else {
          state.permissionSettingList = permissionSettingList;
        }
        state.error = '';
      })
      .addCase(fetchPermissionSettings.rejected, (state, action) => {
        state.loading = false;
        state.permissionSettingList = [];
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(fetchPermissionTypesForView.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
      })
      .addCase(fetchPermissionTypesForView.fulfilled, (state, action) => {
        state.loading = false;
        let viewPermissionTypeList = action.payload;
        if (viewPermissionTypeList && viewPermissionTypeList?.length > 0) {
          state.viewPermissionTypeList = viewPermissionTypeList?.map(
            (item) => ({
              ...item,
              nameAr: item?.nameAr,
              nameEn: item?.nameEn,
              label: getLabel(item?.nameAr, item?.nameEn),
              id: item?.id,
              value: item?.id,
              workFlowID: item?.workFlowID,
            })
          );
        }
        state.error = '';
      })
      .addCase(fetchPermissionTypesForView.rejected, (state, action) => {
        state.loading = false;
        state.viewPermissionTypeList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(addPermissionType.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
      })
      .addCase(addPermissionType.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = { staus: true };
        state.notification = { show: true, code: '200' };
        state.error = '';
      })
      .addCase(addPermissionType.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = {};
        state.error = action.payload ?? 'An error occurred';
      });
      builder
      .addCase(addPermissionSetting.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
      })
      .addCase(addPermissionSetting.fulfilled, (state, action) => {
        if (action.payload) {
          state.permissionTypeAddUpdateDelete = action.payload;
          if (action?.payload?.errCode !== '555') {
            state.notification = { show: true, code: '200' };
            state.error = '';
          }
        }
      })
      .addCase(addPermissionSetting.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = {};
        state.error = action.payload ?? 'An error occurred';
      });
      

    builder
      .addCase(getPermissionTypeById.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
        state.permissionTypeItem = {};
      })
      .addCase(getPermissionTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionTypeItem = action.payload;
        state.error = '';
      })
      .addCase(getPermissionTypeById.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeItem = {};
        state.error = action.payload ?? 'An error occurred';
      });
      builder
      .addCase(getPermissionSettingById.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
        state.permissionSettingItem = {};
      })
      .addCase(getPermissionSettingById.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionSettingItem = action.payload;
        state.error = '';
      })
      .addCase(getPermissionSettingById.rejected, (state, action) => {
        state.loading = false;
        state.permissionSettingItem = {};
        state.error = action.payload ?? 'An error occurred';
      });  
      
    builder
      .addCase(updatePermissionType.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
        state.permissionTypeAddUpdateDelete = {};
      })
      .addCase(updatePermissionType.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = action.payload;
        state.notification = { show: true, code: '200' };
        state.error = '';
      })
      .addCase(updatePermissionType.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = {};
        state.error = action.payload ?? 'An error occurred';
      });
      builder
      .addCase(updatePermissionSetting.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
        state.permissionTypeAddUpdateDelete = {};
      })
      .addCase(updatePermissionSetting.fulfilled, (state, action) => {
        if (action.payload) {
          state.permissionTypeAddUpdateDelete = action?.payload;
          if (action?.payload?.errCode !== '555') {
            state.notification = { show: true, code: '200' };
            state.error = '';
          }
        }
      })
      .addCase(updatePermissionSetting.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = {};
        state.error = action.payload ?? 'An error occurred';
      });  
      
    builder
      .addCase(deletePermissionType.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
        state.permissionTypeAddUpdateDelete = {};
      })
      .addCase(deletePermissionType.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = { status: true };
        state.notification = { show: true, code: '200' };
        state.error = '';
      })
      .addCase(deletePermissionType.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = {};
        state.error = action.payload ?? 'An error occurred';
      });

      builder
      .addCase(deletePermissionSetting.pending, (state) => {
        state.loading = true;
        state.notification = { show: false, code: '' };
        state.permissionTypeAddUpdateDelete = {};
      })
      .addCase(deletePermissionSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = { status: true };
        state.notification = { show: true, code: '200' };
        state.error = '';
      })
      .addCase(deletePermissionSetting.rejected, (state, action) => {
        state.loading = false;
        state.permissionTypeAddUpdateDelete = {};
        state.error = action.payload ?? 'An error occurred';
      });   
  },
});
export const { clearPermissionTypeList } = permissionTypeSlice.actions;

export default permissionTypeSlice.reducer;
